import {refreshAccessToken, isTokenExpired} from './AuthCRUD'
import {identityLoginUrl} from '../../../../setup/appConfig'

let refreshInFlight: Promise<any> | null = null

// Istovremeni zahtjevi dijele jedan refresh, jer se refresh token pri tome mijenja.
function refreshOnce() {
  if (!refreshInFlight) {
    refreshInFlight = refreshAccessToken().finally(() => {
      refreshInFlight = null
    })
  }

  return refreshInFlight
}

async function refreshOrLogout(): Promise<string> {
  const refreshResponse = await refreshOnce()

  if (!refreshResponse?.accessToken) {
    logoutAndRedirect()
    throw new Error('Refresh failed')
  }

  return refreshResponse.accessToken
}

export async function authFetch(url: string, options: RequestInit = {}) {
  let accessToken = localStorage.getItem('accessToken')

  const send = () =>
    fetch(url, {
      ...options,
      credentials: 'include',
      headers: {
        ...options.headers,
        Authorization: accessToken ? `Bearer ${accessToken}` : '',
        'Content-Type': 'application/json',
      },
    })

  // refresh prije requesta
  if (accessToken && isTokenExpired(accessToken)) {
    accessToken = await refreshOrLogout()
  }

  const response = await send()

  // backend vratio 401
  if (response.status === 401) {
    accessToken = await refreshOrLogout()
    return send()
  }

  return response
}

function logoutAndRedirect() {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('persist:v100-demo2-auth')

  sessionStorage.clear()

  window.location.href = identityLoginUrl()
}
